const createTypologyMutation = `
  mutation CreateMarketplaceTypology($fields: CreateMarketplace_typologyFieldsInput) {
    createMarketplace_typology(input: { fields: $fields }) {
      marketplace_typology {
        objectId
        name
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default createTypologyMutation;
